import useMediaView from "features/common/hooks/useMediaView";
import React from "react";
import NoticeCreateWebPage from "./(web)";
import NoticeCreateMobile from "./(mobile)";
const NoticeCreatePage = () => {
  const isSmall = useMediaView("small");
  return <>{isSmall ? <NoticeCreateMobile /> : <NoticeCreateWebPage />}</>;
};

export default NoticeCreatePage;
